import type { FC, ReactElement } from 'react';

import { useSubtitlesViewport } from '../../components/subtitles/hooks/useSubtitlesViewport';
import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../store/CoreStore';
import { useSubtitlesSlice } from '../../store/slices/subtitles/selectors';
import { subtitlesActions } from '../../store/slices/subtitles/slice';
import { ControlContainer } from '../controls/controlContainer/ControlContainer';
import { RadioGroup } from '../controls/radioGroup/RadioGroup';
import { SubtitlesPreview } from '../subtitles/preview/SubtitlesPreview';
import { SubtitlesTextSize } from '../subtitles/types';

import styles from './SettingsSubtitles.module.css';

export const SettingsSubtitlesConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const { deviceType } = useSubtitlesViewport();
  const isSubtitlesEnabled = useSubtitlesSlice.getIsEnabled();
  const subtitlesSize = useSubtitlesSlice.getSizes();

  return (
    <ControlContainer label={<L10nText tk="SETTINGS_SUBTITLES_SIZE" />} column offset>
      <RadioGroup
        className={styles.subtitlesSettingsSize}
        disabled={!isSubtitlesEnabled}
        name="settings-subtitles-size"
        options={[
          {
            label: <L10nText tk="SETTINGS_SUB_SMALL" />,
            value: SubtitlesTextSize.SMALL.toString(),
          },
          {
            label: <L10nText tk="SETTINGS_SUB_MEDIUM" />,
            value: SubtitlesTextSize.MEDIUM.toString(),
          },
          {
            label: <L10nText tk="SETTINGS_SUB_LARGE" />,
            value: SubtitlesTextSize.LARGE.toString(),
          },
        ]}
        onChange={(value) => dispatch(subtitlesActions.setSize({ deviceType, size: value as SubtitlesTextSize }))}
        value={subtitlesSize[deviceType].toString()}
      />
      <SubtitlesPreview sizes={subtitlesSize} subtitle={<L10nText tk="SETTINGS_SUB_PREVIEW" />} />
    </ControlContainer>
  );
};
